import _ from "react";

const URI = (uri: string) => {
  if (uri === "__home__") {
    return "/";
  } else {
    return "/" + uri + "/";
  }
};

export default URI;
